import React from "react";

import { withShowIf } from "../with-show-if/with-show-If.component";

import { BreadcrumbsProps } from "./breadcrumbs.props";
import { BreadcrumbsButton } from "./breadcrumbs-button/breadcrumbs-button.component";

import { useBreadcrumbsStyles } from "./breadcrumbs.styles";

export const Breadcrumbs = withShowIf(({ breadcrumbs }: BreadcrumbsProps) => {
  const classes = useBreadcrumbsStyles();

  const buildCrumbs = () => {
    if (!breadcrumbs.length) {
      return null;
    }

    return breadcrumbs
      .map<React.ReactNode>((breadcrumb, index) => (
        <BreadcrumbsButton key={index} {...breadcrumb} />
      ))
      .reduce((prev, curr) => [prev, "/", curr]);
  };

  return <div className={classes.breadcrumbs}>{buildCrumbs()}</div>;
});
